export default __webpack_public_path__ + "static/media/AMS - List All2.98fb2a1b.svg";